import {
  ADMINISTRATOR,
  MANAGER,
  NORMAL_USER,
  INVALID_CODE_RECEIVED_FOR_USER,
  INVALID_CODE_OR_AUTH_STATE_FOR_THE_USER,
  INVALID_CODE,
  CODE_MISMATCH_AND_FAIL_ENABLE_SOFTWARE_TOKEN_MFA,
  INVALID_VERIFICATION_CODE_PROVIDED,
} from '../constants/UserManagementConstants';

/**
 *
 * @param {Array<Owner>} owners - enriched owner array, not raw ids
 * @param {*} userId
 * @param {*} userRole
 * @returns
 */
export const canUserEditEntity = (owners, userId, userRole) => {
  return (
    ADMINISTRATOR.roleName === userRole ||
    MANAGER.roleName === userRole ||
    (NORMAL_USER.roleName === userRole &&
      owners?.some((user) => user.id === userId))
  );
};

export const canUserEditContact = (userRole) => {
  return (
    ADMINISTRATOR.roleName === userRole ||
    MANAGER.roleName === userRole ||
    NORMAL_USER.roleName === userRole
  );
};

export const cognitoErrorMessageFormatter = (originalMessage) => {
  if (originalMessage === INVALID_CODE_RECEIVED_FOR_USER) {
    return INVALID_CODE;
  }
  if (originalMessage === INVALID_CODE_OR_AUTH_STATE_FOR_THE_USER) {
    return INVALID_CODE;
  }
  if (originalMessage === CODE_MISMATCH_AND_FAIL_ENABLE_SOFTWARE_TOKEN_MFA) {
    return INVALID_CODE;
  }
  if (originalMessage === INVALID_VERIFICATION_CODE_PROVIDED) {
    return INVALID_CODE;
  }
  return originalMessage;
};

export const cognitoLoginErrorMessageFormatter = (
  originalMessage,
  IsSSO = false
) => {
  if (IsSSO && originalMessage === 'Incorrect username or password') {
    return 'Incorrect email address';
  }
  if (originalMessage[originalMessage.length - 1] === '.') {
    return originalMessage.slice(0, -1);
  }

  return originalMessage;
};

export const LAST_SESSION_REFRESH_TIME = 'lastSessionRefresh';

export const TOKEN_REFRESH_WAITING_TIME = 10; // seconds
